/* eslint-disable @typescript-eslint/no-explicit-any */

import type { PhoneNumberConfiguration } from '@/types/phone-number.type';

export const mapPhoneNumberResponse = (data: Record<string, any>): PhoneNumberConfiguration => {
  return {
    id: data.id,
    provider: data.provider,
    name: data.name,
    phone_number: data.phone_number,
    created_at: data.created_at,
    agent: data.agent
      ? {
          id: data.agent.id,
          agent_name: data.agent.agent_name,
        }
      : undefined,
  };
};
